import { ResponsiveBar } from '@nivo/bar';

const customTheme = {
  axis: {
    domain: { line: { stroke: 'transparent' } },
    ticks: { line: { stroke: '#BFF4CB' }, text: { fill: 'transparent' } },
  },
  grid: { line: { stroke: 'transparent' } },
};

// Custom layer that renders a label above the bar with the maximum value
const CustomLabelLayer = ({ bars, yScale }) => {
  // Find the maximum value among the bars
  const maxValue = Math.max(...bars.map((bar) => bar.data.value));
  // Select just the first bar with that maximum value
  const maxBar = bars.find((bar) => bar.data.value === maxValue);
  if (!maxBar) return null;

  const labelText = `Max: ${maxBar.data.value} job(s)`;

  const textX = maxBar.x + maxBar.width / 2;
  const textY = -10;

  return (
    <g key={maxBar.key}>
     
      <text
        x={textX}
        y={textY}
        textAnchor="middle"
        alignmentBaseline="middle"
        style={{
          fill: "#4B5563",
          fontSize: "0.775rem",
          fontFamily:
            "Helvetica Neue, Helvetica, Arial, sans-serif",
        }}
      >
        {labelText}
      </text>
    </g>
  );
};

function RangeHistogram({
  data,
  selectedRange,
  binSize,
  originalMin,
  originalMax,
  valueKey = 'avgAnnualWage',
  animate,
}) {
  // Build bins from originalMin to originalMax in increments of binSize.
  const bins = [];
  for (let bin = originalMin; bin <= originalMax; bin += binSize) {
    bins.push({ binValue: bin, value: 0 });
  }

  // Populate bins
  data.forEach((d) => {
    const value = d[valueKey];
    if (value == null) return;
    const index = Math.floor((value - originalMin) / binSize);
    if (index >= 0 && index < bins.length) {
      bins[index].value += 1;
    }
  });

  return (
    <ResponsiveBar
     
      data={bins}
      animate={animate}
      indexScale={{ type: 'band', round: false }}
      borderRadius={2}
      keys={['value']}
      padding={0.3}
      indexBy="binValue"
      layout="vertical"
      isInteractive={false}
      margin={{ top: 25, right: 0, bottom: 6, left: 0 }}
      colors={(bar) => {
        const binVal = bar.data.binValue;
        return binVal >= selectedRange[0] && binVal < selectedRange[1]
          ? '#7DE2AE'
          : '#F2F2F3';
      }}
      theme={customTheme}
      axisTop={null}
      axisRight={null}
      axisBottom={null}
      axisLeft={null}
      // Disable built-in labels.
      label={null}
      // Add custom layers including our custom label layer.
      layers={['grid', 'axes', 'bars', CustomLabelLayer, 'legends']}
    />
  );
}

export default RangeHistogram;